import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { diemQuyDoiApi } from "../../../api/category/diemQuyDoiApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eDiemQuyDoiActionIds } from "../../action-types/category/IDiemQuyDoiActions";

const mainAction = rootActions.category.diemQuyDoi;

export function* diemQuyDoiSaga(): any {
    yield takeLatest(eDiemQuyDoiActionIds.LOAD_START, loadWorker);
    yield takeEvery(eDiemQuyDoiActionIds.SAVE_START, saveWorker);
    yield takeEvery(eDiemQuyDoiActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
    const res = yield call(diemQuyDoiApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải Điểm quy đổi"));
    }
}

function* saveWorker(action: any): any {
    let res;
    const payload = action.payload;
    if (payload.id_xep_loai > 0) {
        res = yield call(diemQuyDoiApi.Update, payload.id_xep_loai, payload);
    } else {
        res = yield call(diemQuyDoiApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu Điểm quy đổi"));
    }
}

function* deleteWorker(action: any): any {
    const id = action.payload;
    const res = yield call(diemQuyDoiApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa Điểm quy đổi"));
    }
}